import MUIAssignmentIcon from '@mui/icons-material/Assignment'

export const CopyIcon = MUIAssignmentIcon
